<template>
  <div>
    自由客户众筹兑奖记录
    <div class="nav">
      <span 
        v-for="(item,index) in nav" :key="index"
        :class="navActive == index ? 'active' : ''"
        @click="navActive = index"
      >{{ item }}</span>
    </div>
    <el-table>
      <el-table-column label="序号"></el-table-column>
      <el-table-column label="认购投注站站号"></el-table-column>
      <el-table-column label="认购投注站地址"></el-table-column>
      <el-table-column label="认购每股价格"></el-table-column>
      <el-table-column label="认购众筹招股"></el-table-column>
      <el-table-column label="上传实战票"></el-table-column>
      <el-table-column label="兑奖记录"></el-table-column>
      <el-table-column label="备注"></el-table-column>
      <el-table-column label="操作"></el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  data(){
    return{
      nav:['双色球','大乐透'],
      navActive:0
    }
  }
}
</script>

<style lang="scss" scoped>
  .nav{
    span{
      display: inline-block;
      cursor: pointer;
      padding: 10px 50px;
      &.active{
        background-color: #93D2F3;
      }
    }
  }
</style>